export class HealthRegisterPostgraduateTitle {
    titleId: string;
    typeId: string;
    placeOfIssue: string;
    countryId: string;
    dateOfIssue: string;
    dateOfRecognition: string;
    idToCompare: number;
}
